import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=80993820&scoped=true"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=80993820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80993820",
  null
  
)

/* custom blocks */
import block0 from "./ClientCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports